import React, { createContext } from 'react';
import goodfly1 from './Assets/Images/goodfly1.png';
import auction1 from './Assets/Images/auction1.png';
import owyng1 from './Assets/Images/owyng1.png';
import malbygger1 from './Assets/Images/malbygger1.png';
import ttm1 from './Assets/Images/ttm1.png';
import ct1 from './Assets/Images/ct1.png';

export const ProjectsContext = createContext();

export const ProjectsProvider = ({ children }) => {
  const nodes = [
    //     {
    //       title: 'Goodfly Travels',
    //       scope: 'MERN Web App',
    //       description: `Goodfly is  a travel site (ethical, spiritual, excursions and tours), ticketing
    // (online booking of plane, boat, train and coach tickets),hotel and
    // accommodation reservations. (hotels, villas, lodges, apartments, houses, youth
    // hostels, unusual accommodation and prestigious accommodation), an online
    // product store and a news blog.`,
    //       url: 'https://goodfly.netlify.app/',
    //       img: goodfly1,
    //       openSource: false,
    //       tags: ['React Js', 'Node Js', 'Material UI', 'Paypal', 'Amadeus api'],
    //     },
    //     {
    //       title: 'Lotpot Auctions',
    //       scope: 'MERN Web App',
    //       description: `LotPot is an auction marketplace where you can propose the buying and selling of any item or experience you want that you cannot get normally.
    // You can create an auction proposing what the item or experience you want and who can fulfil it – anything from a strange item, an experience with a celebrity, influencer, brand, or business. Get creative!`,
    //       url: 'https://auction-frontend-brown.vercel.app/',
    //       img: auction1,
    //       tags: [
    //         'React Js',
    //         'Stripe',
    //         'AWS',
    //         'Node Js',
    //         'Material UI',
    //         'Socket.io',
    //       ],
    //     },
    {
      title: 'Expense Claimer',
      scope: 'MERN Web App',
      description: `Integrated Paypal Subscriptions for Management of 
       organizations' Employees's Expenses`,
      url: 'https://dashboard.owyng.com/',
      img: owyng1,
      tags: [
        'React Js',
        'Graphql',
        'Paypal',
        'Node Js',
        'Material UI',
        'Express Js',
      ],
    },
    {
      title: 'Malbugger',
      scope: 'Gatsby Firebase WebApp',
      description: `Integrated Stripe Subscriptions for MVP Malbygger Resume Builder.`,
      url: 'https://malbygger.com',
      img: malbygger1,
      tags: ['Gatsby', 'Firebase', 'Stripe'],
    },
    {
      title: 'Team Task Manager App',
      scope: 'MERN Web App',
      description: `The MVP (Minimum Viable Product) in which the Manager manages employees into groups 
      , assign them tasks and arrange meetings`,
      url: 'https://team-task-manager.netlify.app',
      img: ttm1,
      tags: ['React Js', 'Material UI ', 'Node Js'],
    },
    {
      title: 'Task Scheduling App',
      scope: 'MERN Web App',
      description: `The MVP in which the a user can manage his tasks about salary, expense, education
      etc and also generate stats and gets notified when tasks' deadlines finishes!`,
      url: 'https://team-task-manager.netlify.app',
      img: ct1,
      tags: ['React Js', 'Material UI ', 'Node Js'],
    },
  ];
  return (
    <ProjectsContext.Provider value={{ nodes }}>
      {children}
    </ProjectsContext.Provider>
  );
};

export default ProjectsContext;
